import buildConfig from "../../buildConfig";
import initGDSdk from "./gd-sdk";

const setupGdSdk = (game) => {
    const onPause = () => {
        game.sound.mute = true;
        console.log("PAUSE");
    }

    const onStart = () => {
        game.sound.mute = false;
        console.log("START");
    }

    if (buildConfig.gd) {
        initGDSdk({
            onGameStart: () => {
                onStart()
            },
            onGamePause: () => {
                onPause()
            }
        })
        if (typeof gdsdk !== 'undefined' && gdsdk.showAd !== 'undefined') {
            gdsdk.showAd();
        }
    }
}

export const setupBuild = (game) => {
    setupGdSdk(game);
    if (buildConfig) console.log(buildConfig)
}